import { DepositTagType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const depositTagTypeName: { [key in DepositTagType]: TKeyType } = {
  [DepositTagType.CRYPTO]: 'common.cryptoText',
  [DepositTagType.LAST_USED]: '',
  [DepositTagType.RECOMMENDED]: 'common.recommended',
  [DepositTagType.RMB]: 'common.rmbText',
  [DepositTagType.WALLET]: 'common.digitalWallet'
}

export default depositTagTypeName
